import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SupervisionBanner = _resolveComponent("SupervisionBanner")!
  const _component_CriticalIncidenciaBanner = _resolveComponent("CriticalIncidenciaBanner")!
  const _component_SidebarMenu = _resolveComponent("SidebarMenu")!
  const _component_ion_router_outlet = _resolveComponent("ion-router-outlet")!
  const _component_ion_app = _resolveComponent("ion-app")!

  return (_openBlock(), _createBlock(_component_ion_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_SupervisionBanner),
      _createVNode(_component_CriticalIncidenciaBanner),
      (_ctx.userAuth().can('view sidebar'))
        ? (_openBlock(), _createBlock(_component_SidebarMenu, { key: 0 }))
        : _createCommentVNode("", true),
      _createVNode(_component_ion_router_outlet, { id: "main-content" })
    ]),
    _: 1
  }))
}